import styled from 'styled-components';
import { IonPage } from '@ionic/react';

export const IonPageWrapper = styled(IonPage)`
  .log {
    display: flex;
    flex-direction: column-reverse;
  }

  .log-item {
    border: 1px solid #000;
  }
`;